import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
// import { CardActionArea } from "@mui/material";
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import CardActions from "@mui/material/CardActions";
// import theme from "../../theme";
// import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";

type Props = {
  farmer: FarmerInfo;
};

interface FarmerInfo {
  docId: string;
  name: string;
  aboutMe: string | null;
  photoUrl: string | null;
}

export default function ProdutorCardAboutPage({ farmer }: Props) {
  const ref = React.useRef<HTMLDivElement | null>(null);

  const [photoHeight, setphotoHeight] = React.useState(0);
  React.useLayoutEffect(() => {
    if (ref.current) {
      setphotoHeight(ref.current.offsetWidth);
    }
  }, [setphotoHeight]);
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <div ref={ref}>
            <Card>
              {farmer.photoUrl && (
                <CardMedia
                  component="img"
                  alt="Foto do produtor rural cooperado COOPASV"
                  height={photoHeight}
                  image={farmer.photoUrl}
                />
              )}
            </Card>
          </div>
        </Grid>
        <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
          <Card sx={{ minHeight: photoHeight }}>
            <CardContent>
              <Typography gutterBottom variant="h4" align="center">
                {farmer.name}
              </Typography>

              <Typography variant="h6" align="justify">
                {farmer.aboutMe}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
